.Label {
  align-items: center;
  color: var(--rv-fg-2);
  display: flex;
  font-family: var(--rv-font-ui);
  font-size: var(--rv-text-xs);
  font-weight: var(--rv-w-medium);
  margin-bottom: var(--rv-space-1);
}

/* Required marker — the conventional asterisk, in the danger hue so it reads
   as a constraint rather than as the screen's single mint accent. */
.Required {
  color: var(--rv-danger-ink);
  margin-left: var(--rv-space-1);
}

/* Optional tag — deliberately quieter than the label it follows. */
.Optional {
  border: 1px solid var(--rv-border);
  border-radius: var(--rv-radius-sm);
  color: var(--rv-fg-3);
  font-size: var(--rv-text-xxs);
  font-weight: var(--rv-w-regular);
  letter-spacing: 0.02em;
  line-height: 1;
  margin-left: var(--rv-space-2);
  padding: var(--rv-space-1);
  text-transform: uppercase;
}

/* Visually hidden, still announced: the asterisk itself is aria-hidden. */
.SrOnly {
  border: 0;
  clip-path: inset(50%);
  height: var(--space-3xs); /* 1px — 0 can be dropped from the a11y tree */
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: var(--space-3xs);
}
